// src/Views/Articles.js
import React, { useState } from 'react';
import Masonry from 'react-masonry-css';
import './Articles.css';
import { FaComments } from 'react-icons/fa';
import ContactForm from './ContactForm';

//Thumbnails
import aicasethumbnail from '../Assets/images/casestudy/aicasethumbnail.png'; // Placeholder
import returnsthumbnail from '../Assets/images/casestudy/returnsthumbnail.png'; // Placeholder
import ecoscanthumbnail from '../Assets/images/casestudy/ecoscanThumbnail.png'; // Placeholder


const articles = [
  { title: "How i work with ai", image: aicasethumbnail, link: "/case/ai" },
  { title: "Combatting clothing returns", image: returnsthumbnail, link: "/case/returns" },
  { title: "EcoScan App", image: ecoscanthumbnail, link: "/case/eco" },
  // { title: "Coming Soon", image: tempimg1, link: "/case/NaN" },
];

const breakpointColumnsObj = {
  default: 3,
  900: 2,
  600: 1
};

const Articles = () => {
  const [showForm, setShowForm] = useState(false);
  return (
    <section className="articles">
      <Masonry
        breakpointCols={breakpointColumnsObj}
        className="masonry-grid"
        columnClassName="masonry-column"
      >
        {articles.map((article, i) => (
          <a key={i} href={article.link} className="article">
            <div className="thumbnail-wrapper">
              <img src={article.image} alt={article.title} loading="lazy" />
            </div>
            <p className="article-title">{article.title}</p>
          </a>
        ))}
      </Masonry>
      
            {/* Call to Action */}
            <div style={{ textAlign: 'center', marginTop: '4rem' }}>
  <h2 style={{
    fontSize: '2rem',
    fontWeight: '700',
    fontFamily: '"Merriweather Sans", sans-serif',
    marginBottom: '1rem',
    color: '#333'
  }}>
    Interested in learning more about my work?
  </h2>
  <button className="action-btn" onClick={() => setShowForm(true)}>
    <FaComments style={{ marginRight: '8px' }} />
    Contact me
  </button>
</div>

      {showForm && (
        <div className="modal-overlay" onClick={() => setShowForm(false)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <button className="close-modal-btn" onClick={() => setShowForm(false)}>×</button>
            <ContactForm />
          </div>
        </div>
      )}
    </section>
  );
};

export default Articles;